<template>
  <div>
    <md-card slot="top">
      <md-card-header class="text-center">
        <h4>Reasignacion de ReVi</h4>
      </md-card-header>
      <md-card-content class="md-layout md-alignment-space-between">
        <div class="md-layout-item md-size-50 md-layout md-alignment-center">
          <label class="md-layout-item md-size-25">Antiguo ReVi</label>
          <md-field class="md-layout-item ml-auto md-size-70" md-inline>
            <md-select v-model="oldRevi">
              <md-option v-for="revi in revis" :key="revi.id" :value="revi.id">{{ revi.name }}</md-option>
            </md-select>
          </md-field>
        </div>

        <div
          class="md-layout-item md-size-50 md-layout md-alignment-center"
          :class="!oldRevi && 'disabled-field'"
        >
          <label class="md-layout-item md-size-25">Nuevo ReVi</label>
          <md-field class="md-layout-item ml-auto md-size-70">
            <md-select v-model="newRevi" :disabled="!oldRevi">
              <md-option v-for="revi in revis" :key="revi.id" :value="revi.id">{{ revi.name }}</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50 md-layout md-alignment-center">
          <md-field>
            <label for="dateFrom">
              <md-icon>calendar_today</md-icon>
              <span v-show="!dateFrom">Desde</span>
            </label>
            <datetime
              input-style="border: none; outline:none; width: 100%"
              type="date"
              title="Desde"
              value-zone="America/Mexico_City"
              v-model="dateFrom"
              :phrases="{ ok: '', cancel: '' }"
              auto
            ></datetime>
            <md-button class="md-simple md-just-icon" @click="dateFrom = null">
              <md-icon>close</md-icon>
            </md-button>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50 md-layout md-alignment-center">
          <md-field>
            <label for="dateOccurred">
              <md-icon>calendar_today</md-icon>
              {{ dateTo ? "" : "Hasta" }}
            </label>
            <datetime
              input-style="border: none; outline:none; width: 100%"
              type="date"
              title="Hasta"
              value-zone="America/Mexico_City"
              v-model="dateTo"
              :phrases="{ ok: '', cancel: '' }"
              auto
            ></datetime>
            <md-button class="md-simple md-just-icon" @click="dateTo = null">
              <md-icon>close</md-icon>
            </md-button>
          </md-field>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-size-90" :class="!oldRevi && 'disabled-field'">
            <md-field>
              <label>Proceso(s)</label>
              <md-select v-model="selectedProcesses" name="process" id="process" multiple>
                <md-optgroup
                  v-for="(
                    { name: label, color, processes }, i
                  ) in processesGrouped"
                  :key="i"
                  :label="label"
                  :class="`macro-${color}`"
                >
                  <md-option
                    v-for="process in processes"
                    :class="{
                      'included-option': includePastProcesses,
                    }"
                    :key="process.id"
                    :value="process.id"
                  >{{ process.name }}</md-option>
                </md-optgroup>
              </md-select>
            </md-field>
          </div>
          <md-checkbox
            v-model="includePastProcesses"
            class="md-layout-item ml-auto md-size-100"
          >Incluir los procesos anteriores</md-checkbox>
        </div>
      </md-card-content>
      <md-card-actions class="md-layout">
        <span
          v-if="canReassign && sinistersCount"
          class="mr-auto text-warning"
        >Esta acción reasignara {{ sinistersCount }} siniestros.</span>
        <span
          v-if="!$can('re_assign_revi', 'Roads', 'sinisterroads')"
          class="mr-auto text-warning"
        >No tiene permiso para reasignar siniestros</span>
        <md-button
          class="md-round md-primary md-sm"
          :disabled="
            !canReassign || !$can('re_assign_revi', 'Roads', 'sinisterroads')
          "
          @click="doReassignation"
        >
          <md-icon>check</md-icon>Reasignar
        </md-button>
      </md-card-actions>
    </md-card>

    <loading-content
      v-if="!displaySinisters"
      :loading="loading"
      empty-icon="assignment_return"
      empty-label="Reasignacion de ReVi"
      :empty-description="!oldRevi ? 'Seleccione un Residente' : ''"
    />

    <road-sinisters
      v-else
      :process="macroProcessSlug"
      :process-since="includePastProcesses"
      :key="`${oldRevi}@${macroProcess}@${componentKey}`"
      hide-filters
      :show-table-actions="false"
      :filter-defaults="{
        revi: oldRevi,
        dateFrom: dateFrom, 
        dateTo: dateTo,
        before: true,
        jobTypeId: 1,
      }"
      :table-props="{
        selectable: true,
        title: tableTitle,
      }"
      @update:paginationInfo="updateListStatus"
    ></road-sinisters>
  </div>
</template>
<script>
import RoadSinisters from "@/pages/RoadSinisters/Index";
import sinisterService from "@/services/sinister";
import userService from "@/services/user";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "ReviReassignation",

  components: {
    RoadSinisters,
  },

  data() {
    return {
      revis: [],
      oldRevi: null,
      newRevi: null,
      includePastProcesses: true,
      macroProcess: null,
      loading: false,
      sinistersCount: null,
      dateFrom: moment().subtract(15, "days").format("YYYY-MM-DD"),
      dateTo: moment().format("YYYY-MM-DD"),
      componentKey: 0,
    };
  },

  mounted() {
    this.fetchReVis();
  },

  computed: {
    ...mapState("catalogs", {
      processes: (s) => s["macro/Carreteras/process"],
      statuses: (s) => s["macro/Carreteras/status"],
      cicles: (s) => s["macro/Carreteras/business_cicle"],
    }),
    processesGrouped() {
      const { cicles, statuses, processes } = this;
      return statuses.map((status) => {
        const { id: statusId } = status;
        return {
          ...status,
          color: cicles
            .find((c) => c.id === status.business_cicle)
            .color.replace(" ", "-"),
          processes: processes.filter((p) => p.macro_status == statusId),
        };
      });
    },
    reviName() {
      const { oldRevi } = this;
      return this.revis.find((r) => r.id === oldRevi).name;
    },
    processData() {
      const { macroProcess } = this;
      return macroProcess
        ? this.processes.find((p) => p.id === macroProcess)
        : null;
    },
    macroProcessSlug() {
      const { processData } = this;
      return processData ? processData.slug : null;
    },
    reassignation() {
      const {
        revis,
        oldRevi,
        newRevi,
        includePastProcesses,
        selectedProcesses,
        dateFrom,
        dateTo,
        ...reassignationData
      } = this;
      return {
        oldRevi,
        newRevi,
        dateFrom,
        dateTo,
        onlyStatus: !includePastProcesses,
        status: selectedProcesses[selectedProcesses.length - 1],
      };
    },
    displaySinisters() {
      const { oldRevi, loading, macroProcess } = this;

      return oldRevi && !loading && !!macroProcess;
    },
    pastProcesses() {
      const { macroProcess, includePastProcesses, processes } = this;

      if (!macroProcess || !includePastProcesses) {
        return [];
      }

      const { number: procNumber } = processes.find(
        (p) => p.id === macroProcess
      );
      return processes.filter((p) => p.number < procNumber);
    },
    selectedProcesses: {
      get() {
        const { macroProcess, includePastProcesses } = this;
        if (includePastProcesses) {
          const { pastProcesses } = this;
          return macroProcess
            ? [...pastProcesses.map((p) => p.id), macroProcess]
            : [];
        }
        return macroProcess ? [macroProcess] : [];
      },
      set(val = []) {
        const { pastProcesses, macroProcess, processData } = this;
        const pmap = {};
        val.forEach((p) => (pmap[p] = true));
        const failed = pastProcesses.find(({ id }) => !pmap[id]);

        if (failed) {
          this.macroProcess = failed.id;
        } else {
          this.macroProcess = val && val[val.length - 1];
        }
      },
    },
    tableTitle() {
      let title = "Siniestros Carreteros ";
      const { reviName, processData, includePastProcesses } = this;
      if (reviName) {
        title += `asignados a ${reviName} `;
      }

      if (processData) {
        const sinceStr = includePastProcesses ? " hasta " : " en ";
        title += `${sinceStr} ${processData.name}`;
      }
      return title;
    },
    canReassign() {
      const { oldRevi, newRevi, macroProcess } = this;
      return !!oldRevi && !!newRevi && !!macroProcess;
    },
  },
  watch: {
    dateFrom(value) {
      this.componentKey += 1;
    },
    dateTo(value) {
      this.componentKey += 1;
    },
  },
  methods: {
    fetchReVis() {
      userService.fetchType("revi").then((users) => {
        this.revis = users;
      });
    },
    doReassignation() {
      this.loading = true;
      return sinisterService
        .bulkReviReassignation(this.reassignation)
        .then(() => {
          this.$successMessage({ title: `Siniestros reasignados` });
          this.newRevi = null;
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.loading = false));
    },

    updateListStatus({ count }) {
      this.sinistersCount = count;
    },
  },
};
</script>

<style lang="css" scoped>
.disabled-field label {
  color: #868686 !important;
}
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}
.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}
.before-list-item {
  font-size: 1.6rem;
  padding: 8px 0px 8px 10px;
}
.before-list-item:hover {
  cursor: pointer !important;
  background-color: red;
  font-weight: bold;
  color: white;
}
.date-label {
  top: -9px;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/Reassignation/index.vue